import { AloBase, getDefaultAloBase } from './AloBase'


export interface AloPartenaire extends AloBase {    
    ensId:number
    ptnIsPortage:boolean|null
    ptnFtpLogin:string 
    ptnFtpPass:string
    ptnFtpUrl:string
    ptnRestrictedFlag:string
    ptnIsDisabled:boolean    
    fluxIds:Array<number>
    isSpecific:boolean
    ptnSpecificMessage:string
    hasSpecificMessage:boolean    
    ptnPriorite:number    
}

export const getDefaultAloPartenaire = ():AloPartenaire => {
    return {
        ...getDefaultAloBase(),
        ensId:0,
        ptnIsPortage:null,
        ptnFtpLogin:'',
        ptnFtpPass:'',
        ptnFtpUrl:'ftp://darty-partenaire.centralweb.fr',
        ptnRestrictedFlag:'none',
        ptnIsDisabled:false,
        fluxIds:[],
        isSpecific:false,
        ptnSpecificMessage:'',
        hasSpecificMessage:false,
        ptnPriorite:5
    }
}

export const cleanAloPartenaire = (partenaire:AloPartenaire) => {
    if(!partenaire) return    
    if(!partenaire.id) delete partenaire.id
    if(!partenaire.ensId) delete partenaire.ensId
}
